export const CLINIC = {
  name: "iNetra",
  fullName: "iNetra Laser Eye & Advanced Retina Centre",
  tagline: "World Class Retina & Cataract Care",
  location: "Janak Puri, New Delhi",
  established: "2022",
  phoneDisplay: "83839 41290",
  phoneLink: "tel:+918383941290",
  whatsappBase: "https://wa.me/918383941290",
  email: "Inetralaser@gmail.com",
  emailLink: "mailto:Inetralaser@gmail.com",
  reviewUrl: "https://share.google/nsb5zIFaTIwtWaP3w",
  instagramUrl: "https://www.instagram.com/inetralasereyecare",
  instagramHandle: "inetralasereyecare",
  addressLines: ["B1/516, 2nd Floor, B1 Block,", "Janak Puri, New Delhi – 110058"],
  landmark: "Ujjivan Small Finance Bank / Opposite District Centre",
  mapEmbed:
    "https://www.google.com/maps?q=iNetra%20Laser%20Eye%20%26%20Advanced%20Retina%20Centre%2C%20B1%2F516%2C%20B1%20Block%2C%20Janak%20Puri%2C%20New%20Delhi%2C%20Delhi%20110058&output=embed",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=iNetra%20Laser%20Eye%20%26%20Advanced%20Retina%20Centre%2C%20B1%2F516%2C%20B1%20Block%2C%20Janak%20Puri%2C%20New%20Delhi%2C%20Delhi%20110058",
  hours: [
    { days: "Monday – Saturday", time: "9:00 AM – 9:00 PM" },
    { days: "Sunday", time: "10:00 AM – 3:00 PM" },
  ],
};

export const whatsappLink = (message) =>
  `${CLINIC.whatsappBase}?text=${encodeURIComponent(message)}`;

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Doctors", to: "/doctors" },
  { label: "Services", to: "/services" },
  { label: "Retina", to: "/retina" },
  { label: "Cataract", to: "/cataract" },
  { label: "Technology", to: "/technology" },
  { label: "Contact", to: "/contact" },
];

export const DOCTOR = {
  name: "Dr. S.J. Vikas",
  degrees: "MBBS, MD, FAICO",
  role: "Retina & Cataract Specialist",
  specialties: "Retina, Cataract, Uvea, ROP & Vitreoretinal Diseases",
  training: "All India Institute of Medical Sciences, New Delhi",
  faico: "FAICO — Retina & Vitreous · All India Collegium of Ophthalmology (June 2021)",
  bio: "Dr. SJ Vikas is a renowned name in the field of ophthalmology and eye surgery. With more than 10 years of experience in this profession, he has developed expertise in the treatment of a wide range of eye problems and has performed over 10,000+ successful eye surgeries, including complex vitreoretinal and cataract surgeries. He is also the recipient of numerous accolades; notably, ‘FAICO in Vitreo-Retinal Surgery’ by the All India Collegium of Ophthalmology.",
};

export const DOCTORS = [
  {
    name: DOCTOR.name,
    role: "Retina & Cataract Specialist",
    degrees: DOCTOR.degrees,
    src: "/images/doctor-portrait.jpg",
    alt: "Dr. S.J. Vikas — retina and cataract specialist at iNetra, Janak Puri, New Delhi",
    badges: ["AIIMS, New Delhi", "FAICO — Retina & Vitreous"],
    chips: ["Retina", "Cataract", "Uvea", "ROP", "Vitreoretinal Diseases"],
    stats: [
      ["10+", "Years Experience"],
      ["10,000+", "Eye Surgeries"],
      ["AIIMS", "Trained"],
    ],
    bio: DOCTOR.bio,
    bioLabel: "Read Full Biography",
    profileLink: "/about",
  },
  {
    name: "Dr. Santanu Das",
    role: "Orbit, Oncology, Ophthalmic Plastic & Reconstructive Surgeon",
    degrees: "MBBS, MS (Ophthalmology)",
    src: "/images/doctor-santanu-das.webp",
    alt: "Dr. Santanu Das — orbit, ophthalmic plastic and reconstructive surgeon at iNetra, Janak Puri",
    badges: ["Sankara Eye Hospital, Bangalore", "Siriraj Hospital, Bangkok"],
    chips: ["Orbit", "Oncology", "Ophthalmic Plastic Surgery", "Reconstructive Surgery"],
    quals: [
      "MBBS — Kempegowda Institute of Medical Sciences, Bangalore (Rajiv Gandhi University of Health Sciences)",
      "MS Ophthalmology — Kempegowda Institute of Medical Sciences, Bangalore (Rajiv Gandhi University of Health Sciences)",
      "Fellowship in Orbit & Oculoplasty — Sankara Eye Hospital, Bangalore",
      "International Clinical Fellowship in Orbit, Ophthalmic Plastic & Reconstructive Surgery — Siriraj Hospital, Mahidol University, Bangkok",
    ],
    bioLabel: "View Educational Qualifications",
    hasProfile: true,
  },
];

export const DR_DAS_PROFILE = [
  {
    title: "Lid Problems & Surgical Management",
    blurb: "Corrective and reconstructive surgery for eyelid position, function and injury.",
    items: [
      "Involutional entropion and ectropion surgeries",
      "Cicatricial entropion & ectropion repair (post trauma, burns) with skin graft",
      "Ptosis surgery — levator advancement, posterior white line advancement, MMCR, frontalis flap, frontalis sling & frontalis pulley procedures, including congenital ptosis",
      "Lid tear repair & canalicular tear repair",
      "Lid reconstruction after tumor excision, Mohs surgery and trauma",
      "Lid retraction repair using hard palate graft (thyroid eye disease, facial palsy)",
      "Gold weight insertion for facial palsy",
      "Congenital lid coloboma repair",
      "Distichiasis & trichiasis correction — electro-epilation, grey line split with epilation or cryotherapy",
      "Epiblepharon repair",
    ],
  },
  {
    title: "Cosmetic Lid Procedures",
    blurb: "Aesthetic eyelid procedures performed with reconstructive precision.",
    items: [
      "Upper lid corrective blepharoplasty, direct brow lift & sub-brow blepharoplasty",
      "Lower lid bags — transcutaneous & transconjunctival blepharoplasty",
      "Botox for blepharospasm, hemifacial problems, forehead wrinkles, crow's feet",
    ],
  },
  {
    title: "Orbit & Socket Related Problems",
    blurb: "Medical and surgical care for the eye socket and its contents.",
    items: [
      "Proptosis (prominent eyes) — anterior orbitotomy & lateral orbitotomy for orbital lesions",
      "Thyroid eye disease — medical & surgical management as per EUGOGO protocol; fat decompression, lateral wall & medial wall decompression",
      "Paediatric & adult orbital fracture repair using titanium implants and osteomesh following trauma",
      "Medical & surgical management of orbital cellulitis",
      "Placement of prosthetic eye",
      "Paediatric & adult anophthalmic socket reconstruction — dermis fat graft, oral & buccal mucosal graft, hard palate graft",
      "Evisceration & enucleation with PMMA implant for painful blind eye",
      "Lid-sparing exenteration in cases of mucor and orbital malignancies",
      "Inflammatory orbital diseases — lymphoproliferative disorders, lymphoma, optic nerve inflammation (optic neuritis), extra-ocular muscle swelling (myositis)",
      "Traumatic optic nerve damage following trauma",
    ],
  },
  {
    title: "Epiphora (Watering from Eyes)",
    blurb: "Diagnosis and treatment of tear-drainage and surface causes of watering.",
    items: [
      "Watering due to lid laxity, conjunctivochalasis, punctal stenosis & canalicular obstruction — trephination with stent, punctoplasty with stent, conjunctivochalasis repair, lateral tarsal strip",
      "Dry eye disease & Meibomian gland dysfunction",
      "Congenital nasolacrimal duct obstruction — syringing & probing under endoscopic guidance",
      "Acquired (adult) nasolacrimal duct obstruction — external DCR & endoscopic DCR",
      "Diagnostic dacryoscopy",
      "Botox injection for watering not responding to other treatment modalities",
    ],
  },
  {
    title: "Ocular Surface Disorders",
    blurb: "Care for lesions and chronic conditions of the eye's surface.",
    items: [
      "Ocular surface lesions (OSSN, dermoid, naevus, papilloma and others) — wide excision with AMG",
      "Stevens-Johnson syndrome — lid margin keratinization repair with buccal mucosal graft, entropion repair",
      "Pterygium surgery",
    ],
  },
  {
    title: "Lid, Ocular Surface, Orbital & Lacrimal Gland Tumors",
    blurb: "Tumor excision with careful functional and cosmetic reconstruction.",
    items: [
      "Excision of lid tumors followed by reconstruction",
      "Lateral orbitotomy for orbital tumors and lacrimal gland tumors",
      "Excision of ocular surface tumors and reconstruction using no-touch technique",
      "Excision of moles, cysts, warts, papilloma & other ocular and oculofacial swellings",
    ],
  },
];

export const DR_DAS_INTERESTS = [
  "Stevens-Johnson syndrome, chronic facial palsy, and reconstructive surgery following trauma and tumor excision",
  "Collaborative surgeries with ENT, neurosurgery, head & neck and OMFS surgeons — orbital fractures, endoscopic apical orbital decompression",
  "Collaborative treatment with radiation oncologists for orbital apical lesions",
];

export const TRUST_STATS = [
  { value: 10, suffix: "+", label: "Years Experience" },
  { value: 10000, suffix: "+", label: "Eye Surgeries" },
  { text: "AIIMS", label: "Trained Specialist" },
  { text: "Retina", label: "Advanced Retina Care" },
];

export const RETINA_CATEGORIES = [
  {
    title: "Vitreo-Retinal Surgery",
    blurb: "Micro-incisional surgical care for complex retinal conditions.",
    items: [
      "25G Micro-Incisional (Sutureless) Vitrectomy Surgery",
      "Diabetic Vitrectomy Surgery",
      "Retinal Detachment Surgery",
      "Macular Hole Surgery",
      "ERM (Epiretinal Membrane) Surgery",
      "Silicon Oil Removal Surgery",
    ],
  },
  {
    title: "Intravitreal Injections",
    blurb: "Precise in-clinic injection therapy for retinal diseases.",
    items: ["Vabysmo", "Pagenax", "Eylea", "Accentrix", "Lucentis", "Razumab", "Ozurdex"],
  },
  {
    title: "Retina Laser",
    blurb: "Targeted laser procedures to protect and stabilise the retina.",
    items: [
      "Barrage Retinal Laser",
      "Lattice Retinal Laser",
      "Pan-Retinal Photocoagulation (PRP) Laser",
      "Focal Retinal Laser",
      "Grid Retinal Laser",
    ],
  },
];

export const IOL_TYPES = [
  {
    name: "EDOF IOLs",
    desc: "Extended Depth of Focus lenses are designed to give a continuous range of vision — distance to intermediate — reducing dependence on glasses for many daily activities.",
  },
  {
    name: "Toric IOLs",
    desc: "Lenses that also correct astigmatism (cylinder power) during cataract surgery, for sharper, clearer distance vision.",
  },
  {
    name: "Enhanced Monofocal IOLs",
    desc: "High-quality single-focus lenses with improved intermediate range, set for crisp distance clarity.",
  },
];

export const SPECIALTIES_PRIMARY = [
  { title: "Retina", desc: "Medical and surgical care for diseases of the retina and vitreous, including diabetic eye disease." },
  { title: "Cataract", desc: "Micro-incisional, sutureless cataract surgery with premium lens options." },
  { title: "Uvea", desc: "Diagnosis and long-term care of uveitis and inflammatory eye conditions." },
  { title: "ROP", desc: "Screening and treatment of Retinopathy of Prematurity in newborns." },
  { title: "Vitreoretinal Diseases", desc: "Advanced care for macular holes, retinal detachment and related conditions." },
];

export const SPECIALTIES_OTHER = [
  { title: "Oculoplasty", desc: "Care for eyelid, tear duct and orbit-related concerns." },
  { title: "Squint", desc: "Evaluation and management of squint in children and adults." },
  { title: "Cornea", desc: "Assessment and care for corneal conditions and infections." },
  { title: "Paediatric Ophthalmology", desc: "Gentle, thorough eye examination and care for children." },
  { title: "Uvea", desc: "Specialised care for inflammatory eye disease." },
  { title: "Glaucoma", desc: "Screening and management of glaucoma to protect long-term vision." },
];

export const WHY_CHOOSE = [
  { title: "10+ Years of Clinical Experience", desc: "A decade of specialist ophthalmic practice across a wide range of eye conditions." },
  { title: "10,000+ Successful Eye Surgeries", desc: "Including complex vitreoretinal and cataract procedures." },
  { title: "Specialist Retina & Cataract Care", desc: "Focused expertise in the two areas patients need most." },
  { title: "AIIMS-Trained Ophthalmologist", desc: "Trained at the All India Institute of Medical Sciences, New Delhi." },
  { title: "Advanced Diagnostic Technology", desc: "Modern ophthalmic diagnostic and examination equipment in-clinic." },
  { title: "Comprehensive Eye Care", desc: "Evaluation and treatment for the whole family, under one roof." },
  { title: "Patient-Centred Approach", desc: "Clear explanations, unhurried consultations and honest guidance." },
  { title: "Convenient Janak Puri Location", desc: "Easy to reach — opposite District Centre, open 7 days a week." },
];

export const JOURNEY_STEPS = [
  { title: "Book an Appointment", desc: "Call, WhatsApp or book online — pick a time that suits you." },
  { title: "Comprehensive Eye Evaluation", desc: "A detailed, comfortable examination using modern diagnostics." },
  { title: "Specialist Consultation", desc: "Meet Dr. S.J. Vikas and discuss your eyes in plain language." },
  { title: "Diagnosis & Treatment Planning", desc: "A clear plan — what your eyes need, and what they don't." },
  { title: "Follow-up Care", desc: "Structured reviews so your recovery and vision stay on track." },
];

export const EQUIPMENT_ITEMS = [
  { label: "Auto Refractometer", src: "/images/equip-auto-refractometer.webp", alt: "Auto refractometer at iNetra Laser Eye & Advanced Retina Centre, Janak Puri" },
  { label: "Auto Kerato-Refractometer · Huvitz", src: "/images/equip-kerato-refractometer.webp", alt: "Huvitz auto kerato-refractometer at iNetra, Janak Puri" },
  { label: "Slit Lamp", src: "/images/equip-slit-lamp.webp", alt: "Slit lamp examination microscope at iNetra eye centre" },
  { label: "Fundus Camera", src: "/images/equip-fundus-camera.webp", alt: "Fundus camera for retinal imaging at iNetra" },
  { label: "Refraction Unit", src: "/images/equip-refraction-unit.webp", alt: "Refraction unit with examination chair at iNetra" },
  { label: "OCT Scan", src: "/images/equip-oct-scan.webp", alt: "OCT scanner for retinal diagnosis at iNetra" },
  { label: "Green Laser", src: "/images/equip-perimeter.webp", alt: "Green laser machine for retinal treatment at iNetra" },
  { label: "Diagnostic Room Overview", src: "/images/equip-diagnostic-room.webp", alt: "Diagnostic room overview at iNetra, Janak Puri" },
];

export const GALLERY_ITEMS = [
  { label: "iNetra Reception", src: "/images/clinic-reception.webp", alt: "Reception and waiting area at iNetra Laser Eye & Advanced Retina Centre, Janak Puri" },
  { label: "Diagnostic Room", src: "/images/equip-diagnostic-room.webp", alt: "Diagnostic room at iNetra eye centre, Janak Puri" },
  { label: "Refraction Unit", src: "/images/equip-refraction-unit.webp", alt: "Refraction unit at iNetra" },
  { label: "Huvitz Kerato-Refractometer", src: "/images/equip-kerato-refractometer.webp", alt: "Huvitz auto kerato-refractometer at iNetra" },
  { label: "Slit Lamp", src: "/images/equip-slit-lamp.webp", alt: "Slit lamp at iNetra eye centre" },
  { label: "Fundus Camera", src: "/images/equip-fundus-camera.webp", alt: "Fundus camera for retinal imaging at iNetra" },
  { label: "OCT Scan", src: "/images/equip-oct-scan.webp", alt: "OCT scanner at iNetra" },
  { label: "Green Laser", src: "/images/equip-perimeter.webp", alt: "Green laser machine for retinal treatment at iNetra" },
  { label: "Auto Refractometer", src: "/images/equip-auto-refractometer.webp", alt: "Auto refractometer at iNetra" },
];
